import type { PropType } from 'vue';
import type { PreviewItem, ButtonConfig, FormPreviewAlign } from './form-preview';

/**
 * FormPreview 组件的 props
 */
export const props = {
  /**
   * 头部区域的 key 文本，为空时不显示头部区域
   * @default ''
   */
  headerKey: {
    type: String,
    default: '',
  },

  /**
   * 中间内容区域的项列表，至少需要一组数据
   */
  items: {
    type: Array as PropType<PreviewItem[]>,
    required: true,
    default: () => [],
  },

  /**
   * 底部按钮配置，最多 2 个，为空时不显示底部区域
   * @default []
   */
  buttons: {
    type: Array as PropType<ButtonConfig[]>,
    default: () => [],
  },

  /**
   * 中间内容区（item value）的水平对齐方式；header 金额值始终右对齐，不受此 prop 影响
   * @default 'right'
   */
  align: {
    type: String as PropType<FormPreviewAlign>,
    default: 'right',
  },
};

